module.exports = __webpack_public_path__ + "img/20.90d7061c.svg";